import { render } from "./MainLanding.vue?vue&type=template&id=74b6bbb4&ts=true"
import script from "./MainLanding.vue?vue&type=script&lang=ts"
export * from "./MainLanding.vue?vue&type=script&lang=ts"

import exportComponent from "/root/source/core/frontend/landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__